import { useStatsigUser } from '@statsig/react-bindings';
import { useEffect } from 'react';

import { useImpState } from '../app/hooks';
import { isDev } from '../utils/environments';

export default function useStatsigUserUpdaters() {
  const { updateUserAsync } = useStatsigUser();
  const { consumerInfo, merchantData } = useImpState();

  useEffect(() => {
    updateUserAsync((user) => {
      user.custom = {
        productUUID: merchantData.productUUID,
        localDevelopment: String(isDev()),
      };
      return user;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.productUUID]);

  useEffect(() => {
    updateUserAsync((user) => {
      user.userID = consumerInfo.consumerUUID;
      return user;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consumerInfo.consumerUUID]);
}
